export { HbdAuthor } from "./pages/hbdAuthorManagement";
